import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Scale, Gavel } from "lucide-react";
import { StatusBadge, TruckBadge } from "@/components/Badges";
import { Stars } from "@/components/Rating";
import { fmtDate, money } from "@/lib/api";
import { t } from "@/lib/i18n";

export default function LoadCard({ load, index = 0 }) {
  return (
    <Link
      to={`/loads/${load.id}`}
      data-testid={`load-card-${load.id}`}
      className="hf-card hf-rise block p-5 hover:border-amber-500 hover:shadow-md transition-[border-color,box-shadow] min-w-0"
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-mono text-[11px] uppercase tracking-wider text-slate-500 flex flex-wrap items-center gap-2">{load.shipper_code} · {t(load.commodity)} <Stars rating={load.shipper_rating} size="w-3 h-3" /></p>
          <h3 className="font-display font-bold text-lg sm:text-xl mt-1 flex items-center gap-2 flex-wrap break-words">
            {load.loading_area} <ArrowRight className="w-4 h-4 text-amber-600 shrink-0" /> {load.offloading_area}
          </h3>
        </div>
        <div className="text-right shrink-0">
          <p className="font-mono text-xl font-bold text-slate-900">{money(load.price_per_mt, load.currency || "USD")}</p>
          <p className="font-mono text-[10px] uppercase text-slate-500">{t("per metric ton")}</p>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-slate-600">
        <span className="flex items-center gap-1.5"><Scale className="w-3.5 h-3.5" />{load.tonnage} t</span>
        <span className="flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" />{t("Start")} {fmtDate(load.loading_date)} {t("· Complete")} {fmtDate(load.offloading_date)}</span>
        <span className="flex items-center gap-1.5"><Gavel className="w-3.5 h-3.5" />{load.bid_count} {t("bid")}{load.bid_count === 1 ? "" : "s"}</span>
      </div>
      {(load.loading_region || load.offloading_region) && (
        <p className="mt-1 text-xs font-mono text-slate-500">{load.loading_region || load.loading_country || "—"} → {load.offloading_region || load.offloading_country || "—"}</p>
      )}
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <TruckBadge type={load.truck_type} />
        {load.area_match === "close" && <span className="text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded border border-amber-300 bg-amber-50 text-amber-800" data-testid="close-match-badge">{t("Close match")}</span>}
        <StatusBadge status={load.status} />
        {load.my_bid_status && <span className="text-[11px] font-mono text-slate-500">{t("MY BID:")}</span>}
        {load.my_bid_status && <StatusBadge status={load.my_bid_status} />}
      </div>
    </Link>
  );
}
